import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  template: `
    <div class="modal-header">
      <h4 class="modal-title" id="restart-assessment-title">
        {{ 'rspLanguageWarningTitle' | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'rspModalCloseButtonAriaLabel' | translate"
        (click)="activeModal.dismiss()"
      ></button>
    </div>
    <div class="modal-body" id="restart-assessment-body">
      {{ 'rspLanguageWarningBody' | translate }}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss()">
        {{ 'rspLanguageWarningButtonCancel' | translate }}
      </button>
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('restart')">
        {{ 'rspLanguageWarningButtonAccept' | translate }}
      </button>
    </div>
  `,
  imports: [TranslateModule],
})
export class RestartAssessmentModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
